let sortByPrice = null;
const tagsMap = {
  procesador: "PROCESADOR",
  placa_base: "PLACA BASE",
  ram: "RAM",
  caja: "TORRE",
  refrigeracion_liquida: "REFRIGERACION LIQUIDA",
  refrigeracion_cpu: "REFRIGERACION CPU",
  fuente_alimentacion: "FUENTE ALIMENTACION",
  grafica: "TARJETA GRAFICA",
  disco_duro: "DISCO DURO",
  disco_duro_2: "DISCO DURO",
  tarjeta_de_sonido: "TARJETA SONIDO",
  ventiladores_suplementarios: "VENTILADORES",
  ventiladores_suplementarios_2: "VENTILADORES",
  adaptador_wifi: "ADAPTADOR WIFI",
  SO: "SO"
};

function formatPriceEs(value) {
  const num = typeof value === 'number'
    ? value
    : parseFloat(String(value).replace(',', '.')) || 0;
  return num.toLocaleString('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }) + ' €';
}

  let productsCache = [];
  let currentPage = 1;
  const pageSize = 6;
  let filterTerm = "";

  let currentSocket = "";
  let currentCpuTdp = 0;
  let currentCoolerTdp = 0;

  let currentCaseTag = "";
  let currentBoardTag = "";
  let currentMemoryType = "";
  let currentGpuThreshold = 0;
  let currentPsuW = 0;

function resetConfigurator() {
  currentSocket = "";
  currentCaseTag = "";
  currentBoardTag = "";
  currentMemoryType = "";
  currentGpuThreshold = 0;
  currentPsuW = 0;
  currentTpd = 0;
  currentCpuTdp = 0;
  currentCoolerTdp = 0;
  document.getElementById("summary-list").innerHTML = "";
  document.getElementById("summary-total").textContent = formatPriceEs(0);
  document.getElementById("add-cartBtn").disabled = true;

  categories.forEach(cat => {
    const btn = document.querySelector(`.comp-list-btn[data-key="${cat.key}"]`);
    if (!btn) return;
    btn.querySelector(".comp-list-img").src = cat.image;
    btn.querySelector(".comp-list-img").alt = cat.title;
    btn.querySelector(".comp-list-text").textContent = cat.title.toUpperCase();
    const rm = btn.querySelector(".comp-list-remove-btn");
    if (rm) rm.classList.add("hidden");
  });

  const drawer = document.getElementById("modal-config");
  drawer.classList.replace("modal-right-config-open", "modal-right-config-close");
}

function renderPage() {
  const drawerList = document.getElementById("modal-right-config-list");
  drawerList.innerHTML = "";
  const filtered = productsCache
  .filter(p => p.title.toLowerCase().includes(filterTerm.toLowerCase()))
  .sort((a, b) => {
  const aStock = a.variants[0]?.available ? 1 : 0;
  const bStock = b.variants[0]?.available ? 1 : 0;

  const aCompat = a.incompatible ? 0 : 1;
  const bCompat = b.incompatible ? 0 : 1;

  const stockCompatOrder = (bStock - aStock) || (bCompat - aCompat);
  if (stockCompatOrder !== 0) return stockCompatOrder;

  if (sortByPrice === "asc") {
    return (parseFloat(a.variants[0]?.price || 0) - parseFloat(b.variants[0]?.price || 0));
  }
  if (sortByPrice === "desc") {
    return (parseFloat(b.variants[0]?.price || 0) - parseFloat(a.variants[0]?.price || 0));
  }
  return 0;
});


  const start = (currentPage - 1) * pageSize;
  const slice = filtered.slice(start, start + pageSize);

  if (slice.length === 0) {
    const none = document.createElement("li");
    none.className = "li-item-config";
    none.textContent = "No hay productos disponibles";
    drawerList.appendChild(none);
  } else {
    slice.forEach(prod => {
      const li = document.createElement("li");
      li.className = "li-item-config";
      if (prod.incompatible && prod.variants[0]?.available) {
        li.classList.add("incompatible-product");
      }

      const a = document.createElement("a");
      a.href = `/products/${prod.handle}.html`;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.className = "link-item-config";

      const img = document.createElement("img");
      img.src = prod.images[0]?.src || "";
      img.alt = prod.title;
      img.className = "config-producto-img";
      a.appendChild(img);

      const h4 = document.createElement("h4");
      let txt = prod.title.replace(/\s+/g, " ").trim();
      if (txt.length > 40) txt = txt.slice(0, 40) + "…";
      h4.textContent = txt;
      h4.className = "config-producto-title";
      a.appendChild(h4);

      const priceP = document.createElement("p");
      priceP.textContent = formatPriceEs(prod.variants[0]?.price || 0);
      priceP.className = "config-producto-price";
      a.appendChild(priceP);

      const btn = document.createElement("button");
      btn.className = "config-producto-btn";
      if (prod.variants[0]?.available) {
        btn.textContent = prod.incompatible ? "Incompatible" : "Seleccionar";
        btn.disabled = prod.incompatible;
        if (!prod.incompatible) {
          btn.addEventListener("click", e => {
            e.preventDefault();
            handleSelect(prod);
          });
        }
      } else {
        btn.textContent = "Sin stock";
        btn.disabled = true;
      }

      a.appendChild(btn);

      li.appendChild(a);
      drawerList.appendChild(li);
    });
  }

  const totalPages = Math.ceil(filtered.length / pageSize);
  if (totalPages > 1) {
    renderPaginationControls(totalPages);
  } else {
    const pg = document.getElementById("pagination-controls");
    if (pg) pg.remove();
  }
}

function renderPaginationControls(totalPages) {
  let pager = document.getElementById("pagination-controls");
  if (!pager) {
    pager = document.createElement("div");
    pager.id = "pagination-controls";
    document.querySelector(".modal-right-config-body").appendChild(pager);
  }
  pager.innerHTML = "";

  const prev = document.createElement("button");
  prev.textContent = "<";
  prev.disabled = currentPage === 1;
  prev.classList.add("pagination-button");
  prev.addEventListener("click", () => {
    currentPage--;
    renderPage();
  });

  const span = document.createElement("span");
  span.textContent = `Página ${currentPage} de ${totalPages}`;

  const next = document.createElement("button");
  next.textContent = ">";
  next.disabled = currentPage === totalPages;
  next.classList.add("pagination-button");
  next.addEventListener("click", () => {
    currentPage++;
    renderPage();
  });

  pager.append(prev, span, next);
}

function updateAddCartButton() {
  const req = ["procesador","placa_base","ram","caja","fuente_alimentacion","disco_duro"];
  const ok = req.every(k => document.querySelector(`#summary-list li[data-key="${k}"]`));
  document.getElementById("add-cartBtn").disabled = !ok;
}

document.addEventListener("DOMContentLoaded", () => {
  const grid = document.querySelector(".config-options");
  const container = document.getElementById("components-list");
  const drawer = document.getElementById("modal-config");
  const closeBtn = document.getElementById("modal-right-config-close");
  const addCartBtn = document.getElementById("add-cartBtn");
  addCartBtn.disabled = true;

  closeBtn.addEventListener("click", () => {
    drawer.classList.replace("modal-right-config-open", "modal-right-config-close");
  });

options.forEach(opt => {
  const div = document.createElement("div");
  div.className = "config-item";
  const img = document.createElement("img");
  img.src = opt.image;
  img.alt = opt.title;
  img.className = "config-item__img";
  const p = document.createElement("p");
  p.textContent = opt.title;
  p.className = "config-item__title";
  const btn = document.createElement("button");
  btn.textContent = "Seleccionar";
  btn.className = "config-item__btn";
  btn.setAttribute("data-socket", opt.key.toUpperCase());
  btn.addEventListener("click", () => {
    document.querySelectorAll(".config-item__btn").forEach(b => {
      b.classList.remove("selected");
    });
    btn.classList.add("selected");
    if (currentSocket && currentSocket !== opt.key.toUpperCase()) resetConfigurator();
    currentSocket = opt.key.toUpperCase();
    document.querySelector(".list-configurator").classList.remove("hidden");
  });
  div.append(img, p, btn);
  grid.appendChild(div);
});


  categories.forEach(cat => {
    const wrapper = document.createElement("div");
    wrapper.className = "comp-list-box";

    const btnCat = document.createElement("button");
    btnCat.className = "comp-list-btn";
    btnCat.setAttribute("data-key", cat.key);

    const icon = document.createElement("img");
    icon.className = "comp-list-img";
    icon.src = cat.image; icon.alt = cat.title;

    const txt = document.createElement("p");
    txt.className = "comp-list-text";
    txt.textContent = cat.title.toUpperCase();

    const removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "comp-list-remove-btn";
    removeBtn.textContent = "✕";
    removeBtn.classList.add("hidden");

    removeBtn.addEventListener("click", e => {
      e.stopPropagation();
      icon.src = cat.image;
      icon.alt = cat.title;
      txt.textContent = cat.title.toUpperCase();
      removeBtn.classList.add("hidden");
    
      const old = document.querySelector(`#summary-list li[data-key="${cat.key}"]`);
      if (old) old.remove();
    
      switch (cat.key) {
        case "procesador":
          currentCpuTdp = 0;
          break;
        case "refrigeracion_liquida":
        case "refrigeracion_cpu":
          currentCoolerTdp = 0;
          break;
        case "caja":
          currentCaseTag = "";
          break;
        case "placa_base":
          currentBoardTag = "";
          currentMemoryType = "";
          break;
        case "ram":
          currentMemoryType = "";
          break;
        case "grafica":
          currentGpuThreshold = 0;
          break;
        case "fuente_alimentacion":
          currentPsuW = 0;
          break;
      }
    
      actualizarTotal();
      updateAddCartButton();
    });



    btnCat.append(icon, txt, removeBtn);
    wrapper.appendChild(btnCat);
    container.appendChild(wrapper);

    btnCat.addEventListener("click", () => {
      window.selectedCategoryKey = cat.key;
      document.querySelector(".modal-right-config-title").textContent = cat.title.toUpperCase();

      const body = document.querySelector(".modal-right-config-body");
      const sortContainer = document.createElement("div");
      sortContainer.className = "sort-controls";
      
      const sortAscBtn = document.createElement("button");
      sortAscBtn.textContent = "Precio ↑";
      sortAscBtn.className = "sort-button";
      
      const sortDescBtn = document.createElement("button");
      sortDescBtn.textContent = "Precio ↓";
      sortDescBtn.className = "sort-button";
      
      sortContainer.append(sortAscBtn, sortDescBtn);

      let si = document.getElementById("product-search");
      if (!si) {
        si = document.createElement("input");
        si.id = "product-search";
        si.type = "text";
        si.placeholder = "Buscar…";
        si.classList.add("product-search-input");
        body.insertBefore(si, body.firstChild);
        si.addEventListener("input", e => {
          filterTerm = e.target.value;
          currentPage = 1;
          renderPage();
        });
      }
      const existingSort = document.querySelector(".sort-controls");
      if (!existingSort) {
        const sortContainer = document.createElement("div");
        sortContainer.className = "sort-controls";
      
        const sortAscBtn = document.createElement("button");
        sortAscBtn.textContent = "Precio ↑";
        sortAscBtn.className = "sort-button";
      
        const sortDescBtn = document.createElement("button");
        sortDescBtn.textContent = "Precio ↓";
        sortDescBtn.className = "sort-button";
      
        sortContainer.append(sortAscBtn, sortDescBtn);
        body.insertBefore(sortContainer, si.nextSibling);
      
        const updateSortButtonUI = () => {
          [sortAscBtn, sortDescBtn].forEach(btn => btn.classList.remove("selected"));
          if (sortByPrice === "asc") sortAscBtn.classList.add("selected");
          else if (sortByPrice === "desc") sortDescBtn.classList.add("selected");
        };
      
        sortAscBtn.addEventListener("click", () => {
          sortByPrice = "asc";
          updateSortButtonUI();
          renderPage();
        });
      
        sortDescBtn.addEventListener("click", () => {
          sortByPrice = "desc";
          updateSortButtonUI();
          renderPage();
        });
      
        updateSortButtonUI();
      }

      filterTerm = "";
      si.value = "";

      const extras = [];
      if (cat.key === "placa_base") {
        if (currentCaseTag) extras.push(currentCaseTag);
        if (currentSocket)   extras.push(currentSocket);
      }
      if (cat.key === "caja") {
        if (currentBoardTag) extras.push(currentBoardTag);
      }
      if (cat.key === "ram") {
        if (currentMemoryType) extras.push(currentMemoryType);
      }
      if (cat.key === "procesador") {
        if (currentSocket) extras.push(currentSocket);
      }

      llamadaAPI(tagsMap[cat.key], extras, 0);
      drawer.classList.replace("modal-right-config-close", "modal-right-config-open");
    });
  });

  const soCheckbox    = document.getElementById("pc-config-so");
  const soPriceSpan   = document.getElementById("price-win-mont");
  const soLabel       = document.querySelector("label[for='pc-config-so']");
  const montCheckbox  = document.getElementById("pc-config-mont");
  const montLabel     = document.querySelector("label[for='pc-config-mont']");

  fetchWindows11ProVariantId().then(id => id && (soCheckbox.value = id));
  fetchMontajePCVariantId().then(id => id && (montCheckbox.value = id));

  soCheckbox.addEventListener("change", () => {
    const list = document.getElementById("summary-list");
    const key  = "SO";
    const existing = list.querySelector(`li[data-key="${key}"]`);
    if (soCheckbox.checked && !existing) {
      let raw = soPriceSpan.textContent.replace("€","").trim().replace(/\./g,"").replace(",",".");
      const precio = parseFloat(raw) || 0;
      const li = document.createElement("li");
      li.className = "list-items-config-added config-summary-justify";
      li.dataset.key = key;
      li.dataset.variantId = soCheckbox.value;
      const tSpan = document.createElement("span");
      tSpan.className = "summary-item-title";
      tSpan.textContent = soLabel.textContent.split("por")[0].trim();
      const pSpan = document.createElement("span");
      pSpan.className = "summary-item-price";
      pSpan.dataset.price = precio;
      pSpan.textContent = formatPriceEs(precio);
      li.append(tSpan, pSpan);
      list.appendChild(li);
    }
    if (!soCheckbox.checked && existing) existing.remove();
    actualizarTotal();
    updateAddCartButton();
  });

  montCheckbox.addEventListener("change", () => {
    const list = document.getElementById("summary-list");
    const key  = "MONTAJE";
    const existing = list.querySelector(`li[data-key="${key}"]`);
    if (montCheckbox.checked && !existing) {
      const rawText = document.getElementById("price-mont").textContent
        .replace(/\u00a0/g, "")
        .replace("€", "")
        .trim()
        .replace(/\./g, "")
        .replace(",", ".");
      const price = parseFloat(rawText) || 0;
  
      const li = document.createElement("li");
      li.className = "list-items-config-added config-summary-justify";
      li.dataset.key = key;
      li.dataset.variantId = montCheckbox.value;
  
      const tSpan = document.createElement("span");
      tSpan.className = "summary-item-title";
      tSpan.textContent = "Recibir ordenador montado";
  
      const pSpan = document.createElement("span");
      pSpan.className = "summary-item-price";
      pSpan.dataset.price = price;
      pSpan.textContent = formatPriceEs(price);
  
      li.append(tSpan, pSpan);
      list.appendChild(li);
    }
    if (!montCheckbox.checked && existing) existing.remove();
    actualizarTotal();
    updateAddCartButton();
  });



  addCartBtn.addEventListener("click", async () => {
    const items = [];
    document.querySelectorAll("#summary-list li[data-variant-id]").forEach(li => {
      const id  = parseInt(li.dataset.variantId, 10);
      const inp = li.querySelector("input");
      const qty = inp ? parseInt(inp.value,10)||1 : 1;
      items.push({ id, quantity: qty });
    });
    if (!items.length) return;
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type':'application/json' },
      body: JSON.stringify({ items })
    });
    window.location.href = '/cart';
  });

});

  async function llamadaAPI(tagBuscado, extraTags = [], sinceId) {
    const drawerList = document.getElementById("modal-right-config-list");
    drawerList.innerHTML = "";
    const liLoad = document.createElement("li");
    liLoad.className = "li-item-config";
    liLoad.textContent = "Cargando…";
    drawerList.appendChild(liLoad);

    const limit = 250;
    let lastId = sinceId;
    productsCache = [];
    currentPage = 1;
    const tagU = tagBuscado.toUpperCase();

    while (true) {
      const res = await fetch(`/products.json?limit=${limit}&since_id=${lastId}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const { products } = await res.json();

   const filt = products.map(p => {
      if (!Array.isArray(p.tags)) return null;
      const U = p.tags.map(t => t.toUpperCase());
      if (!U.includes(tagU)) return null;
      let incompatible = false;
      if (!extraTags.every(t => U.includes(t))) {
        incompatible = true;
      }
      if ((tagU === tagsMap.refrigeracion_liquida.toUpperCase() || tagU === tagsMap.refrigeracion_cpu.toUpperCase()) && currentCpuTdp > 0) {
        const coolerTag = U.find(t => /\d+\s?W/.test(t));
        if (!coolerTag || parseInt(coolerTag, 10) < currentCpuTdp) incompatible = true;
      }
      if (tagU === tagsMap.procesador.toUpperCase() && currentSocket) {
        if (!U.includes(currentSocket)) return null;
      }

      if (tagU === tagsMap.placa_base.toUpperCase() && currentSocket) {
        if (!U.includes(currentSocket)) return null;
      }
      if (tagU === tagsMap.fuente_alimentacion.toUpperCase() && currentGpuThreshold > 0) {
        const psu = U.find(t => /\d+\s?W/.test(t));
        if (!psu || parseInt(psu, 10) < currentGpuThreshold) incompatible = true;
      }
      if (tagU === tagsMap.grafica.toUpperCase() && currentPsuW > 0) {
        const gpuWtag = U.find(t => /\d+\s?W/.test(t));
        if (!gpuWtag || parseInt(gpuWtag, 10) + 200 > currentPsuW) incompatible = true;
      }
      if (tagU === tagsMap.caja.toUpperCase() && currentBoardTag) {
        const boxTags = U.filter(t => /MINI ITX|MICRO ATX|ATX|E-ATX/i.test(t));
        if (!boxTags.some(bt => bt.toUpperCase() === currentBoardTag)) {
          incompatible = true;
        }
      }
      if (tagU === tagsMap.ram.toUpperCase() && currentMemoryType) {
        const ramType = U.find(t => /DDR[2345]/i.test(t));
        if (!ramType || ramType.toUpperCase() !== currentMemoryType) {
          return null;
        }
      }

      return {
        ...p,
        incompatible
      };
    }).filter(Boolean);

      productsCache.push(...filt);
      if (products.length < limit) break;
      lastId = products[products.length - 1].id;
    }

    renderPage();
  }

async function fetchVariantIdByTitle(titleToFind) {
  let sinceId = 0;
  const limit = 250;
  while (true) {
    const res = await fetch(`/products.json?limit=${limit}&since_id=${sinceId}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const { products } = await res.json();
    const prod = products.find(p=>p.title.toUpperCase()===titleToFind.toUpperCase());
    if (prod) return prod.variants[0]?.id ?? null;
    if (products.length < limit) return null;
    sinceId = products[products.length-1].id;
  }
}

async function fetchWindows11ProVariantId() {
  return await fetchVariantIdByTitle('Windows 11 Pro Oficial (Instalado/Montaje)');
}
async function fetchMontajePCVariantId() {
  return await fetchVariantIdByTitle('Montaje PC');
}

function actualizarTotal() {
  let t = 0;
  document.querySelectorAll(".summary-item-price").forEach(el=>{
    t += parseFloat(el.dataset.price)||0;
  });
  document.getElementById("summary-total").textContent = formatPriceEs(t);
}

function handleSelect(product) {
  const key = window.selectedCategoryKey;
  if (!key) return;

  const variantId = product.variants[0]?.id;
  const priceBase = parseFloat(product.variants[0]?.price) || 0;
  const title     = product.title;
  const list      = document.getElementById("summary-list");
  const old       = list.querySelector(`li[data-key="${key}"]`);
  if (old) old.remove();

  const li = document.createElement("li");
  li.classList.add("config-summary-list-item");
  li.dataset.key = key;
  li.dataset.variantId = variantId;

  const titleSpan = document.createElement("span");
  titleSpan.className = "summary-item-title";
  titleSpan.textContent = title;

  const priceSpan = document.createElement("span");
  priceSpan.className = "summary-item-price";
  priceSpan.dataset.price = priceBase;
  priceSpan.textContent    = formatPriceEs(priceBase);

  if (["ram","disco_duro","disco_duro_2"].includes(key)) {
    const qtyInput = document.createElement("input");
    qtyInput.type  = "number";
    qtyInput.min   = "1";
    qtyInput.value = "1";
    qtyInput.classList.add("summary-item-qty");
    qtyInput.addEventListener("change", () => {
      const q = parseInt(qtyInput.value,10)||1;
      const tot = priceBase * q;
      priceSpan.dataset.price = tot;
      priceSpan.textContent = formatPriceEs(tot);
      actualizarTotal();
      updateAddCartButton();
    });
    li.append(qtyInput, titleSpan, priceSpan);
  } else {
    li.classList.add("config-summary-justify");
    li.append(titleSpan, priceSpan);
  }

  list.appendChild(li);
  actualizarTotal();
  updateAddCartButton();

      if (key === "procesador") {
      const tdpTag = product.tags.find(t => /\d+\s?W/i.test(t));
      if (tdpTag) {
        currentCpuTdp = parseInt(tdpTag, 10);
      }
    }
  if (key === "caja") {
    const box = product.tags.find(t=>/MINI ITX|MICRO ATX|ATX|E-ATX/i.test(t));
    if (box) currentCaseTag = box.toUpperCase();
  }
  if (key === "placa_base") {
    const brd = product.tags.find(t=>/MINI ITX|MICRO ATX|ATX|E-ATX/i.test(t));
    if (brd) currentBoardTag = brd.toUpperCase();
    const mem = product.tags.find(t=>/DDR[2345]/i.test(t));
    if (mem) currentMemoryType = mem.toUpperCase();
  }
  if (key === "grafica") {
    const pow = product.tags.find(t=>/\d+\s?W/i.test(t));
    if (pow) currentGpuThreshold = parseInt(pow,10) + 200;
  }
  if (key === "fuente_alimentacion") {
    const puw = product.tags.find(t=>/\d+\s?W/i.test(t));
    if (puw) currentPsuW = parseInt(puw,10);
  }
  if (key === "procesador") {
    const tdpTag = product.tags.find(t => /\d+\s?W/i.test(t));
    if (tdpTag) currentCpuTdp = parseInt(tdpTag, 10);
  }
  if (key === "refrigeracion_liquida" || key === "refrigeracion_cpu") {
    const coolerTag = product.tags.find(t => /\d+\s?W/i.test(t));
    if (coolerTag) currentCoolerTdp = parseInt(coolerTag, 10);
  }


  document.getElementById("modal-config").classList.replace(
    "modal-right-config-open", "modal-right-config-close"
  );

  const btnCat = document.querySelector(`.comp-list-btn[data-key="${key}"]`);
  btnCat.querySelector(".comp-list-img").src  = product.images[0]?.src || "";
  btnCat.querySelector(".comp-list-text").textContent = product.title;
  const rm = btnCat.querySelector(".comp-list-remove-btn");
  if (rm) rm.classList.remove("hidden");
}

window.handleSelect = handleSelect;
